import Cards from '../components/Cards.jsx';
import { social } from '../config/site.js';
import cardsData from '../data/sandbox.json';

export default function Music() {
  const soundcloud = social.find(s => s.label === 'SoundCloud');
  const bandcamp   = social.find(s => s.label === 'Bandcamp');
  return (
    <>
      <section className="page-content">
        <h1><em>Sandbox</em></h1>
        <p>
        Music is at the heart of everything we do at WAABM. From ambient explorations to
        collaborative compositions, every piece reflects a unique perspective brought to life
        through sound.
      </p>
      <p>
        Browse our releases across SoundCloud, Bandcamp, and streaming platforms. Each release
        is an invitation to listen closely — and to find something of yourself in the notes.
      </p>
      </section>
      <Cards data={cardsData} />
      <section className="page-content">
        <p>
          <a href={soundcloud.url} target="_blank" rel="noreferrer">Listen on SoundCloud</a>
          {' · '}
          <a href={bandcamp.url} target="_blank" rel="noreferrer">Browse Bandcamp</a>
        </p>
      </section>
    </>
  );
}
